export const defaultDateFilterOptions = () => {
  return [
    {
      label: 'Today',
      key: 'today',
      selected: false,
    },
    {
      label: 'Earlier this year',
      key: 'earlierThisYear',
      selected: false,
    },
    {
      label: 'Earlier this month',
      key: 'earlierThisMonth',
      selected: false,
    },
    {
      label: 'Beyond this year',
      key: 'beyondThisYear',
      selected: false,
    },
    {
      label: 'Yesterday',
      key: 'yesterday',
      selected: false,
    },
    {
      label: 'Prior to this Year',
      key: 'priorThisYear',
      selected: false,
    },
    {
      label: 'Last Week',
      key: 'lastWeek',
      selected: false,
    },
    {
      label: 'Next Week',
      key: 'nextWeek',
      selected: false,
    },
    {
      label: 'Later this year',
      key: 'laterThisYear',
      selected: false,
    },
    {
      label: 'Later this month',
      key: 'laterThisMonth',
      selected: false,
    },
    {
      label: 'Earlier this week',
      key: 'earlierThisWeek',
      selected: false,
    },
  ]
}
